import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

type ProjectState = {
  isHidingUnpinnedProjects: boolean;
  updateIsHidingUnpinnedProjects: (isHiding: boolean) => void;
};

const useProjectStore = create<ProjectState>()(
  devtools(
    persist(
      (set) => ({
        isHidingUnpinnedProjects: false,
        updateIsHidingUnpinnedProjects: (isHiding) =>
          set(() => ({ isHidingUnpinnedProjects: isHiding })),
      }),
      { name: 'projectStore' }
    )
  )
);

export const useProjectState = () =>
  useProjectStore((state) => ({
    isHidingUnpinnedProjects: state.isHidingUnpinnedProjects,
  }));

export const useProjectActions = () =>
  useProjectStore((state) => ({
    updateIsHidingUnpinnedProjects: state.updateIsHidingUnpinnedProjects,
  }));

export default useProjectStore;
